/**
 * How far in the future an event may be scheduled, and therefore how far
 * ahead the feed, search and explore queries look for upcoming events.
 *
 * The create form and every upcoming-events query must share this value:
 * if the form allowed later dates than the queries fetched, those events
 * would exist but never be shown.
 */
export const MAX_EVENT_LEAD_MS = 365 * 24 * 60 * 60 * 1000; // 1 year

/** Latest permitted event start time, measured from now. */
export function maxEventStart(now: Date = new Date()): Date {
  return new Date(now.getTime() + MAX_EVENT_LEAD_MS);
}
